import React, { useEffect, useState } from 'react';
import { canContinuePreparedOffline, shouldReadPreparedDirectly } from '../offline/offlineSession';

export default function OfflineBanner() {
  const [reachable, setReachable] = useState(navigator.onLine !== false);
  const [authenticationPending, setAuthenticationPending] = useState(shouldReadPreparedDirectly);
  const [dismissed, setDismissed] = useState(false);
  const [storagePressure, setStoragePressure] = useState(false);
  useEffect(() => {
    const online = () => { setReachable(true); setAuthenticationPending(shouldReadPreparedDirectly()); };
    const offline = () => { setReachable(false); setDismissed(false); };
    const reachability = event => {
      if (typeof event.detail?.reachable !== 'boolean') return;
      setReachable(event.detail.reachable);
      if (!event.detail.reachable) setDismissed(false);
    };
    const auth = () => { if (canContinuePreparedOffline()) setAuthenticationPending(true); };
    const refreshed = () => setAuthenticationPending(shouldReadPreparedDirectly());
    const pressure = () => setStoragePressure(true);
    window.addEventListener('offline', offline);
    window.addEventListener('online', online);
    window.addEventListener('vela:api-reachability', reachability);
    window.addEventListener('vela:session-expired', auth);
    window.addEventListener('vela:offline-session-changed', refreshed);
    window.addEventListener('vela:logged-in', refreshed);
    window.addEventListener('storage', refreshed);
    window.addEventListener('vela:offline-storage-pressure', pressure);
    return () => {
      window.removeEventListener('offline', offline);
      window.removeEventListener('online', online);
      window.removeEventListener('vela:api-reachability', reachability);
      window.removeEventListener('vela:session-expired', auth);
      window.removeEventListener('vela:offline-session-changed', refreshed);
      window.removeEventListener('vela:logged-in', refreshed);
      window.removeEventListener('storage', refreshed);
      window.removeEventListener('vela:offline-storage-pressure', pressure);
    };
  }, []);
  if (!authenticationPending && !storagePressure && (reachable || dismissed)) return null;
  return <div className="fixed left-3 right-3 top-20 z-50"><div className="mx-auto max-w-6xl"><div role="status" className="flex items-start gap-3 rounded-lg border border-yellow-300 bg-yellow-100 px-4 py-2 text-sm text-yellow-900 shadow">
    <span className="flex-1">{authenticationPending
      ? 'Sign in to sync. Prepared offline-enabled episodes remain available; online-only charts require a connection. “Saved on this device” confirms a local copy; “All changes synced” confirms the server has your submitted changes.'
      : storagePressure ? 'Device storage is getting full. Active episodes and unsynced work are kept; preparing other charts is limited.'
        : 'Connection unavailable. Online-only charts require a connection. For prepared offline-enabled charts, “Saved on this device” confirms a local copy. After reconnecting, “All changes synced” confirms the server has your submitted changes. Transfers and contraction timer actions require a connection.'}</span>
    {authenticationPending && <button type="button" onClick={() => window.open(`/login?from=${encodeURIComponent(window.location.pathname)}`, '_blank', 'noopener,noreferrer')} className="whitespace-nowrap underline">Sign in to sync</button>}
    {!authenticationPending && !storagePressure && <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss offline notice" className="rounded p-1">✕</button>}
  </div></div></div>;
}
